// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "assets/scripts/" + ({22: "a12",545: "vendors",}[chunkId] || chunkId) + "." + {22: "6c179884",334: "c9871e23",375: "51145d43",479: "9eb708d0",545: "f86b1d5d",588: "7bd85d57",808: "d39727c0",891: "0ab30222",909: "29c0b434",}[chunkId] + ".bundle.js"
}